import { IconButton } from '@components'
import { Button, Heading, Text } from '@here/components'
import { A } from '@solidjs/router'
import { AtSign, Bell, BellOff } from 'lucide-solid'
import { type Component, For, Show } from 'solid-js'
import { createEffect } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Flex, Grid } from 'styled-system/jsx'
import { useChannelsReads } from '../../../state/channelReads/state'
import { useMessageMention } from '../../../state/mentions/useMentions'
import { useSelectors } from '../../../state/selectors'
import { UnreadCount } from '../UnreadCount'

const style = css({
	'& button': {
		borderColor: 'tscGreen.10',
	},
})

const formatString = (input: string): string => input.replace(/-/g, ' ')

const Channels: Component<{ height?: string; isMinimal?: boolean }> = (props) => {
	const { generalChannels } = useService(useSelectors)()
	const { messageMentionChannelMap } = useService(useMessageMention)()
	const { toggleSubscribed, channelReadsRefetch, channelSeenResource } =
		useService(useChannelsReads)()

	createEffect(() => {
		if (channelSeenResource.state === 'ready') {
			channelReadsRefetch()
		}
	})

	return (
		<>
			<Flex
				overflow="auto"
				height={props.height || 'calc(50vh - 81px)'}
				alignItems="stretch"
				gap={1}
				direction="column"
			>
				<For each={generalChannels()}>
					{(channel) => (
						<Grid gridTemplateColumns="1fr auto" gap={1}>
							<A
								href={channel.name === 'general' ? '/chat' : `/chat/${channel.name}`}
								end={channel.name === 'general'}
								activeClass={style}
							>
								<Button
									colorPalette='bg'
                  size='xs'
									variant={props.isMinimal ? 'link' : 'outline'}
                  _hover={{ color: props.isMinimal ? 'tscGreen.emphasized': '' }}
									width="100%"
									justifyContent="space-between"
								>
									<Text
										textTransform="capitalize"
										children={formatString(channel.name)}
									/>
									<Flex
										alignItems="center"
										gap={1}
									>
										<Show when={messageMentionChannelMap()[channel.id]?.length}>
											<AtSign />
										</Show>
										<Show when={channel.unreadCount}>
											<UnreadCount
												lastReadAt={channel.unreadCount}
												channelId={channel.id}
											/>
										</Show>
									</Flex>
								</Button>
							</A>
							<Show when={!props.isMinimal}>
								<IconButton
                  size='xs'
									colorPalette={channel.isSubscribed ? 'tscGreen' : 'fg'}
									variant="subtle"
									onClick={() => toggleSubscribed(channel.id)}
								>
									<Show
										when={channel.isSubscribed}
										fallback={<BellOff />}
									>
										<Bell />
									</Show>
								</IconButton>
							</Show>
						</Grid>
					)}
				</For>
			</Flex>
		</>
	)
}

export default Channels
